import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles((theme) => ({
  formControl: {
    // margin: theme.spacing(1),    
    padding: 0,
    marginLeft: 0,
    minWidth: 120,
    maxWidth: 120,
    backgroundColor: "#fff",
    "& .MuiInputBase-root": {
      borderRadius: 0
    }
    // border: "1px solid",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    padding: 8,
    fontSize: "0.8rem",
    fontFamily: "OpenSans",
  },
  paperRoot: {
    transformOrigin: "unset !important",
    // top: "250px !important"
  }
}));


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;


export default function SingleSelect(props) {
  const { labelKey, items, onChange, defaultValue, idKey, styles, disabled = false } = props;
  const classes = useStyles();
  const [selected, setSelected] = React.useState('');

  const handleChange = (event) => {
    setSelected(event.target.value);
    let selectedItem = labelKey ? items.filter(item => event.target.value === item[labelKey])[0] : event.target.value
    onChange(selectedItem);
  };
  const MenuProps = {
    autoFocus: false,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left', },
    classes: { paper: classes.paperRoot },
    variant: "menu",
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        // width: 250,
      },
    },
  };
  React.useEffect(() => {
    if (defaultValue && items.length) {
      if (idKey) {
        let selectedValue = items.filter(item => defaultValue == item[idKey])[0]
        setSelected(selectedValue[labelKey])
        onChange(selectedValue)
      }
      else if (labelKey) {
        setSelected(defaultValue[labelKey])
        onChange(defaultValue)
      }
      else {
        setSelected(defaultValue)
        onChange(defaultValue)
      }
    }
    else if (items[0]) {
      setSelected(labelKey ? items[0][labelKey] : items[0])
      onChange(items[0])
    }
  }, [items, labelKey, defaultValue])

  return (
    <div>
      <FormControl className={classes.formControl} variant="outlined" style={styles}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selected}
          onChange={handleChange}
          MenuProps={MenuProps}
          defaultValue={items[0] ? items[0][labelKey] : ""}
          classes={{ outlined: classes.select }}
          IconComponent={KeyboardArrowDownIcon}
          disabled={disabled}
        >

          {items.map((item) => (
            <MenuItem
              key={labelKey ? item[labelKey] : item}
              value={labelKey ? item[labelKey] : item}>{labelKey ? item[labelKey] : item}</MenuItem>))
          }

        </Select>
      </FormControl>

    </div>
  )
}
